import { render, staticRenderFns } from "./PasswordResetRoute.vue?vue&type=template&id=dfb934a4"
import script from "./PasswordResetRoute.vue?vue&type=script&lang=ts"
export * from "./PasswordResetRoute.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports